import { Course } from '../types';

export const dadfoundry_blueprint: Course = {
  id: "dadfoundry_blueprint",
  title: "DadFoundry Blueprint",
  description: "The core mechanics of navigating fatherhood legally and emotionally.",
  icon: "⚙️",
  totalModules: 14,
  modules: {
    1: { id: 1, title: "Slide 1", slides: [{ title: "Slide 1", content: `<div class="flex justify-center"><img src="/images/courses/dadfoundry_blueprint/Slide1.PNG" alt="Slide 1" class="w-full h-auto max-w-3xl rounded-xl shadow-md border border-slate-200" /></div>` }] },
    2: { id: 2, title: "Slide 2", slides: [{ title: "Slide 2", content: `<div class="flex justify-center"><img src="/images/courses/dadfoundry_blueprint/Slide2.PNG" alt="Slide 2" class="w-full h-auto max-w-3xl rounded-xl shadow-md border border-slate-200" /></div>` }] },
    3: { id: 3, title: "Slide 3", slides: [{ title: "Slide 3", content: `<div class="flex justify-center"><img src="/images/courses/dadfoundry_blueprint/Slide3.PNG" alt="Slide 3" class="w-full h-auto max-w-3xl rounded-xl shadow-md border border-slate-200" /></div>` }] },
    4: { id: 4, title: "Slide 4", slides: [{ title: "Slide 4", content: `<div class="flex justify-center"><img src="/images/courses/dadfoundry_blueprint/Slide4.PNG" alt="Slide 4" class="w-full h-auto max-w-3xl rounded-xl shadow-md border border-slate-200" /></div>` }] },
    5: { id: 5, title: "Slide 5", slides: [{ title: "Slide 5", content: `<div class="flex justify-center"><img src="/images/courses/dadfoundry_blueprint/Slide5.PNG" alt="Slide 5" class="w-full h-auto max-w-3xl rounded-xl shadow-md border border-slate-200" /></div>` }] },
    6: { id: 6, title: "Slide 6", slides: [{ title: "Slide 6", content: `<div class="flex justify-center"><img src="/images/courses/dadfoundry_blueprint/Slide6.PNG" alt="Slide 6" class="w-full h-auto max-w-3xl rounded-xl shadow-md border border-slate-200" /></div>` }] },
    7: { id: 7, title: "Slide 7", slides: [{ title: "Slide 7", content: `<div class="flex justify-center"><img src="/images/courses/dadfoundry_blueprint/Slide7.PNG" alt="Slide 7" class="w-full h-auto max-w-3xl rounded-xl shadow-md border border-slate-200" /></div>` }] },
    8: { id: 8, title: "Slide 8", slides: [{ title: "Slide 8", content: `<div class="flex justify-center"><img src="/images/courses/dadfoundry_blueprint/Slide8.PNG" alt="Slide 8" class="w-full h-auto max-w-3xl rounded-xl shadow-md border border-slate-200" /></div>` }] },
    9: { id: 9, title: "Slide 9", slides: [{ title: "Slide 9", content: `<div class="flex justify-center"><img src="/images/courses/dadfoundry_blueprint/Slide9.PNG" alt="Slide 9" class="w-full h-auto max-w-3xl rounded-xl shadow-md border border-slate-200" /></div>` }] },
    10: { id: 10, title: "Slide 10", slides: [{ title: "Slide 10", content: `<div class="flex justify-center"><img src="/images/courses/dadfoundry_blueprint/Slide10.PNG" alt="Slide 10" class="w-full h-auto max-w-3xl rounded-xl shadow-md border border-slate-200" /></div>` }] },
    11: { id: 11, title: "Slide 11", slides: [{ title: "Slide 11", content: `<div class="flex justify-center"><img src="/images/courses/dadfoundry_blueprint/Slide11.PNG" alt="Slide 11" class="w-full h-auto max-w-3xl rounded-xl shadow-md border border-slate-200" /></div>` }] },
    12: { id: 12, title: "Slide 12", slides: [{ title: "Slide 12", content: `<div class="flex justify-center"><img src="/images/courses/dadfoundry_blueprint/Slide12.PNG" alt="Slide 12" class="w-full h-auto max-w-3xl rounded-xl shadow-md border border-slate-200" /></div>` }] },
    13: { id: 13, title: "Slide 13", slides: [{ title: "Slide 13", content: `<div class="flex justify-center"><img src="/images/courses/dadfoundry_blueprint/Slide13.PNG" alt="Slide 13" class="w-full h-auto max-w-3xl rounded-xl shadow-md border border-slate-200" /></div>` }] },
    14: { id: 14, title: "Slide 14", slides: [{ title: "Slide 14", content: `<div class="flex justify-center"><img src="/images/courses/dadfoundry_blueprint/Slide14.PNG" alt="Slide 14" class="w-full h-auto max-w-3xl rounded-xl shadow-md border border-slate-200" /></div>` }] }
  },
  quiz: [
    {
        "q": "Based on the \"Upgrading the Fatherhood Operating System\" slide, what is a key characteristic of the \"DadFoundry Model\" for \"Role Definition\"?",
        "o": [
            "The Silent Protector",
            "The Emotionally Present Partner",
            "Total Sacrifice",
            "Transactional Roommates"
        ],
        "a": 1
    },
    {
        "q": "According to the \"Structural Brain Changes\" slide, what is the status of neural pathways linked to empathy and emotional vigilance in new fathers?",
        "o": [
            "Down-regulated",
            "Asynchronous",
            "Upgraded",
            "Unchanged"
        ],
        "a": 2
    },
    {
        "q": "The \"Chronic Sleep Deprivation Triggers the Cortisol Trap\" slide identifies \"Misplaced Dad Rage or Extreme Frustration\" as a direct consequence of what preceding state in the loop?",
        "o": [
            "Hyper-Vigilance Leading to Worse Sleep",
            "Immense Paternal Guilt",
            "Chronic Fight-or-Flight State (Cortisol Spike)",
            "Severe Sleep Deprivation"
        ],
        "a": 2
    },
    {
        "q": "What does the \"Briefing Note\" on the \"Male Paternal Depression Presents\" slide state about how paternal depression typically manifests?",
        "o": [
            "It looks like weeping.",
            "It looks like retreating.",
            "It looks like anger management issues.",
            "It looks like overworking."
        ],
        "a": 1
    },
    {
        "q": "Which immediate tactical tool is recommended for \"breaking the mental spiral of the Cortisol Trap,\" according to the \"Immediate Tactical Tools\" slide?",
        "o": [
            "Box Breathing (The 4-Second Square)",
            "The 5-4-3-2-1 System Override",
            "The 10-Minute Check-In Protocol",
            "Guaranteed 4-Hour REM Block"
        ],
        "a": 1
    },
    {
        "q": "In the \"Micromanagement and Withdrawal Feedback Loop,\" what is identified as the core problem to address to fix the dynamic?",
        "o": [
            "The partner's micromanagement tendencies.",
            "The dad's emotional withdrawal.",
            "The entire system, not attacking the teammate.",
            "The partner feeling abandoned with the mental load."
        ],
        "a": 2
    },
    {
        "q": "What is the primary purpose of \"Step 2: Fuel Level Readings\" in \"The 10-Minute Check-In Protocol\"?",
        "o": [
            "To synchronize logistics and define tasks.",
            "To focus on low-energy emotional connection.",
            "To non-judgmentally report current physical and emotional bandwidth.",
            "To identify the highest-leverage self-care activity."
        ],
        "a": 2
    },
    {
        "q": "According to the \"Precision Sleep Requires Overlapping Shift Protocols\" slide, what is a \"non-negotiable operational baseline\" for effective sleep in new parents?",
        "o": [
            "Ensuring the partner gets uninterrupted sleep.",
            "Fragmented sleep for both parents.",
            "Guaranteeing one 4-hour block of REM sleep for each parent.",
            "Relying solely on the \"Dad Shift.\""
        ],
        "a": 2
    },
    {
        "q": "What is the recommended duration for \"Phase 2: Shed\" within \"The 5-Minute Buffer Zone\" protocol?",
        "o": [
            "5 minutes",
            "10 minutes",
            "3 minutes",
            "As long as needed"
        ],
        "a": 2
    },
    {
        "q": "In \"The Readiness Stack: The Architecture of Paternal Mental Fitness,\" what is the ultimate goal (Level 4)?",
        "o": [
            "Operational Tactics",
            "Biological Regulation",
            "Relationship Resilience",
            "A fully upgraded fatherhood operating system"
        ],
        "a": 3
    }
]
};
